<template>
    <div id="ppanel-catalog"
         class="ppanel-listing"
    >
        <node-tree
                :catalogs="bookData.catalog[0].catalog"
                :depth="0"
                v-if="bookData.catalog.length"
        >
        </node-tree>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, inject}  from "vue";
    import NodeTree from "@/views/reader/ppanel/NodeTree";
    import {useDataLoader} from "@/modules/reader/book/dataLoader";
    import {usePpanel}  from "@/modules/reader/ppanel/ppanel";

    export default {
        components: {
            NodeTree
        },
        setup(props, context) {

            const { bookData} = useDataLoader();
            const {pPanelState} = usePpanel();
            const i18n = inject('i18n');

            const data = reactive({
                heading: bookData.catalog[0].title
                //heading: i18n.t("label_content")
            })

            onMounted(()=>{
                pPanelState.isToolEnabled =  bookData.catalog[0].catalog.length > 0;
            })

            return {
                data,
                bookData
            }
        }

    }

</script>

<style scoped lang="scss">


</style>